import { type PropsWithChildren, useRef, type JSX } from 'react';

import { type Store, createStore } from '../../../core/store/store.js';
import { TreeMapStateContext, initialTreeMapState } from '../store/store.js';
import type { TreeMapState } from '../types/state.js';

interface StoreProviderProps {
  value?: TreeMapState;
}

export const StoreProvider = ({
  value,
  children,
}: PropsWithChildren<StoreProviderProps>): JSX.Element => {
  const storeRef = useRef<Store<TreeMapState>>(undefined);

  storeRef.current = createStore(value ?? initialTreeMapState);

  return (
    <TreeMapStateContext.Provider value={storeRef.current}>
      {children}
    </TreeMapStateContext.Provider>
  );
};
